import React from "react";
import { Api } from "../app-controller.js";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import MuestraForm from "../components/visits/MuestraForm";
import FotosVisita from "../components/visits/FotosVisita";
import {
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import HojaRemisionMuestra from "../components/content/visits/hoja_remision_muestra";
import classnames from "classnames";
import Swal from "sweetalert2";

class VisitDrycip extends React.Component {
  initialState = {
    previa: false,
    previa_url: "",
    nivelUsuario: localStorage.nivel_actual,
    locations: Api.loadCatalogue("locations"),
    municipios: [],
    opciones_pais: Api.loadCatalogue("countries"),
    cat_actividad: Api.loadCatalogue("cat_actividad"),
    cat_tipo_encuesta: Api.loadCatalogue("cat_tipo_encuesta"),
    working: true,
    toggle: false,
    paginaActual: 0,
    paginaActual_vi: 0,
    paginas: 0,
    paginas_vi: 0,
    registros: 0,
    registros_vi: 0,
    visitas: [],
    activeTab: "1",
    buscar: {},
    collapse: [
      {
        id: 1,
        collapse: true,
      },
      {
        id: 2,
        collapse: false,
      },
    ],
  };

  constructor(props) {
    super(props);

    this.state = this.initialState;
  }

  regente = {};

  toggleTab = (tab) => {
    if (this.state.activeTab !== tab) {
      this.setState({ activeTab: tab });
    }
  };

  toggleCollapse = (index) => {
    var newArray = [];
    for (let collapseObj of this.state.collapse) {
      if (collapseObj.id === index) {
        collapseObj.collapse = !collapseObj.collapse;
      } else {
        collapseObj.collapse = false;
      }
      newArray.push(collapseObj);
    }

    this.setState({ collapse: newArray });
  };

  getAnalisisResultadosData = (visita_id) => {
    Api.loading(true);
    Api.fetch("app/getAnalisisResultadosData?visita_id=" + visita_id).then(
      (data) => {
        Api.loading(false);
      }
    );
  };

  toggle = () => {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  };

  componentDidMount() {
    // si el usuario no es nivel inspector redireccionamos a home
    console.log(this.state.nivelUsuario);
    if (this.state.nivelUsuario !== "3") {
      window.location.href = "/";
    }

    this.setState({ buscar: this.search });
    this.setVisitasPage(1);
  }

  // Inicia logica que controla la pestaña de regente (grid y detalle)
  search = [];

  handleSearch = (obj) => {
    // Si el obj.target.name pertenece a un input type text aplicamos la funcion
    // toUpperCase()
    ["folio", "folio_manual", "nombre_razon"].includes(obj.target.name)
      ? (this.search[obj.target.name] = obj.target.value.toUpperCase())
      : (this.search[obj.target.name] = obj.target.value);

    // si obj.target name pertenece a fecha, habilitamos la fecha2
    if (obj.target.name === "fecha") {
      document.getElementById("fecha2").removeAttribute("disabled");
      if (this.state.buscar.hasOwnProperty("fecha2")) {
        document.getElementById("fecha2").value = "";
        delete this.search["fecha2"];
      }
    }

    // filtramos municipios por el departamento_id
    if (obj.target.name === "departamento_id") {
      document.getElementById("municipio_id").value = "";
      document.getElementById("pais_id").value = "";
      delete this.search["municipio_id"];
      delete this.search["pais_id"];

      let result = this.state.locations.municipios.filter(
        (municipio) => municipio.estado_id === obj.target.value
      );

      this.setState({ municipios: result });
    }

    if (obj.target.name === "pais_id") {
      document.getElementById("departamento_id").value = "";
      document.getElementById("municipio_id").value = "";
      delete this.search["municipio_id"];
      delete this.search["departamento_id"];

      this.setState({ municipios: [] });
    }

    this.setState({ buscar: this.search });
  };

  cleanSearch = () => {
    let search = this.state.buscar;

    for (const prop in search) {
      delete search[prop];
      document.getElementById(prop).value = "";

      if (prop === "fecha") {
        document.getElementById("fecha2").setAttribute("disabled", true);
      }
    }

    this.setState({ buscar: search, municipios: [] });
    this.setVisitasPage(1);
  };

  //Funcion para cambiar de pagina en el grid de regente
  setVisitasPage = (page) => {
    this.setState({ workingGrid: true });
    let search = this.state.buscar;
    let src = "";
    for (let param in search) {
      if (search[param] !== "") {
        src += "&" + param + "=" + search[param];
      }
    }

    Api.fetch("app/getVisitasDrycip?page=" + page + src).then((v) => {
      this.setState({
        visitas: v.data,
        paginas: v.last_page,
        registros: v.total,
        paginaActual: v.current_page,
        workingGrid: false,
      });
    });
  };

  handleVisitasPage = (e) => {
    this.setVisitasPage(e.target.value);
  };

  handleClick_v = (e) => {
    this.setState({
      previa: true,
      previa_url: Api.url + `app/visita/?id=${e.target.id}`,
    });
  };

  render() {
    return (
      <div className="row">
        <div className="col-xl-12">
          <Nav tabs={true}>
            <NavItem>
              <NavLink
                className={classnames({
                  active: this.state.activeTab === "1",
                })}
                onClick={() => {
                  this.toggleTab("1");
                }}
              >
                <span className="d-sm-none">
                  VISITAS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros}
                  </span>
                </span>
                <span className="d-sm-block d-none">
                  VISITAS
                  <span className="label label-success m-l-5 t-minus-1">
                    {this.state.registros}
                  </span>
                </span>
              </NavLink>
            </NavItem>
          </Nav>
          <TabContent activeTab={this.state.activeTab}>
            <TabPane tabId="1">
              <div className="table-responsive">
                <fieldset>
                  <legend>Buscar visita</legend>

                  <div className="row">
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="folio">Folio:</label>
                        <div className="input-group">
                          <input
                            id="folio"
                            name="folio"
                            placeholder="Ingrese folio"
                            onChange={this.handleSearch}
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="folio_manual">Folio manual:</label>
                        <div className="input-group">
                          <input
                            id="folio_manual"
                            name="folio_manual"
                            onChange={this.handleSearch}
                            placeholder="Ingrese folio manual"
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="nombre_razon">
                          Nombre establecimiento:
                        </label>
                        <div className="input-group">
                          <input
                            id="nombre_razon"
                            name="nombre_razon"
                            onChange={this.handleSearch}
                            placeholder="Ingrese establecimiento"
                            className="form-control"
                            type="text"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="actividad_id">Actividad:</label>
                        <div className="input-group">
                          <select
                            name="actividad_id"
                            id="actividad_id"
                            onChange={this.handleSearch}
                            className="form-control"
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Seleccionar
                            </option>
                            {this.state.cat_actividad.map((actividad) => (
                              <option key={actividad.id} value={actividad.id}>
                                {actividad.descripcion.toUpperCase()}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="pais_id">País:</label>
                        <div className="input-group">
                          <select
                            name="pais_id"
                            id="pais_id"
                            onChange={this.handleSearch}
                            className="form-control"
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Seleccionar
                            </option>
                            {this.state.opciones_pais.map((op) => (
                              <option key={op.id} value={op.id}>
                                {op.descripcion.toUpperCase()}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="departamento_id">Departamento:</label>
                        <div className="input-group">
                          <select
                            name="departamento_id"
                            id="departamento_id"
                            onChange={this.handleSearch}
                            className="form-control"
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Seleccionar
                            </option>
                            {this.state.locations.departamentos.map((dep) => (
                              <option key={dep.id} value={dep.id}>
                                {dep.name.toUpperCase()}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="municipio_id">Municipio:</label>
                        <div className="input-group">
                          <select
                            name="municipio_id"
                            id="municipio_id"
                            onChange={this.handleSearch}
                            className="form-control"
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Seleccionar
                            </option>
                            {this.state.municipios.map((mun) => (
                              <option key={mun.id} value={mun.id}>
                                {mun.name.toUpperCase()}
                              </option>
                            ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="estatus">Estado:</label>
                        <div className="input-group">
                          <select
                            name="estatus"
                            id="estatus"
                            onChange={this.handleSearch}
                            className="form-control"
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Seleccionar
                            </option>
                            <option value="1">REGISTRADO</option>
                            <option value="2">NO REGISTRADO</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="tipo_visita">Tipo visita:</label>
                        <div className="input-group">
                          <select
                            name="tipo_encuesta_id"
                            id="tipo_encuesta_id"
                            onChange={this.handleSearch}
                            className="form-control"
                            defaultValue=""
                          >
                            <option value="" disabled>
                              Seleccionar
                            </option>
                            {this.state.cat_tipo_encuesta
                              .sort((a, b) =>
                                a.descripcion.toUpperCase() >
                                b.descripcion.toUpperCase()
                                  ? 1
                                  : -1
                              )
                              .map((encuesta) => (
                                <option key={encuesta.id} value={encuesta.id}>
                                  {encuesta.descripcion.toUpperCase()}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="fecha">Fecha desde:</label>
                        <div className="input-group">
                          <input
                            type="date"
                            name="fecha"
                            onChange={this.handleSearch}
                            id="fecha"
                            className="form-control"
                            placeholder="Fecha"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="fecha2">Fecha hasta:</label>
                        <div className="input-group">
                          <input
                            type="date"
                            min={this.state.buscar["fecha"]}
                            name="fecha2"
                            onChange={this.handleSearch}
                            disabled
                            id="fecha2"
                            className="form-control"
                            placeholder="Fecha"
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-3">
                      <div className="form-group">
                        <label htmlFor="search">&nbsp;</label>
                        <div className="input-group">
                          <button
                            type="button"
                            className="btn btn-orange w-100"
                            title="Buscar"
                            onClick={() => this.setVisitasPage(1)}
                          >
                            <i className="fa fa-search"></i> Buscar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </fieldset>
                <table className="table table-striped m-b-0 table-hover">
                  <thead>
                    <tr>
                      <th className="text-center">Folio</th>
                      <th className="text-center">Folio manual</th>
                      <th className="text-center">Establecimiento</th>
                      <th className="text-center">Actividad</th>
                      <th className="text-center">Fecha</th>
                      <th className="text-center">Locación</th>
                      <th className="text-center">Tipo</th>
                      <th className="text-center">Estado</th>
                      {/* <th></th>
                      <th></th>
                      <th></th> */}
                      <th></th>
                    </tr>
                  </thead>
                  <tbody className={this.state.workingGrid ? "hide" : ""}>
                    {this.state.visitas &&
                    Object.keys(this.state.visitas).length > 0 ? (
                      this.state.visitas.map((v) => (
                        <tr
                          key={v.id}
                          className={
                            v.dias > 15 && v.estatus === "En espera"
                              ? "alerta"
                              : ""
                          }
                        >
                          <td className="text-center">{v.folio}</td>
                          <td className="text-center">
                            {v.folio_manual ? v.folio_manual : "N/A"}
                          </td>
                          <td className="text-center">
                            {v.nombre_razon.toUpperCase()}
                          </td>
                          <td
                            className="text-center"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={
                              v.nombre_actividad ? v.nombre_actividad : "N/A"
                            }
                          >
                            {v.nombre_actividad
                              ? v.nombre_actividad.length > 22
                                ? v.nombre_actividad
                                    .substring(0, 30)
                                    .toUpperCase() + "..."
                                : v.nombre_actividad.toUpperCase()
                              : "N/A"}
                          </td>

                          <td className="text-center">
                            {/* {format(new Date(v.fecha), "dd/MM/yyyy")} */}
                            {v.fecha.split("-").reverse().join("/")}
                          </td>
                          <td className="text-center">
                            {!v.departamento_id
                              ? v.pais_texto.toUpperCase()
                              : `${v.nombre_municipio.toUpperCase()}, ${v.nombre_departamento.toUpperCase()}`}
                          </td>
                          <td
                            className="text-center"
                            data-toggle="tooltip"
                            data-placement="top"
                            title={v.nombre_encuesta}
                          >
                            {[
                              "1",
                              "2",
                              "3",
                              "8",
                              "9",
                              "10",
                              "11",
                              "12",
                              "13",
                            ].includes(v.tipo_encuesta_id)
                              ? v.nombre_encuesta.slice(
                                  0,
                                  Math.round(v.nombre_encuesta.length) / 2
                                ) + "..."
                              : v.nombre_encuesta}
                          </td>
                          <td className="text-center">
                            {v.establecimiento_id == null
                              ? "NO REGISTRADO"
                              : "REGISTRADO"}
                          </td>
                          <td>
                          <div
                                onClick={this.handleClick_v}
                                name="boton-encuesta"
                                width="60"
                                title="Vista previa"
                                id={v.id}
                                data-encuesta={v.tipo_encuesta_id}
                                className="btn btn-danger"
                            >
                                <i
                                className="fa fa-file-pdf"
                                name="pdf"
                                id={v.id}
                                ></i>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="9" className="text-center">
                          <b>No se encontraron registros</b>
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
                <div className={this.state.workingGrid ? "m-10" : "hide"}>
                  <div className="progress-bar bg-orange progress-bar-striped progress-bar-animated">
                    CARGANDO INFORMACIÓN
                  </div>
                </div>
                <hr />
                <div className="d-flex align-items-center justify-content-center">
                  <ul className="pagination mb-0">
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setVisitasPage(1);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-left"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (this.state.paginaActual - 1 > 0) {
                            this.setVisitasPage(this.state.paginaActual - 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-left"></i>
                      </button>
                    </li>
                    <li className="page-item d-flex align-items-center px-2">
                      <div>
                        Página
                        <strong>
                          {" "}
                          {this.state.paginaActual} de {this.state.paginas}
                        </strong>
                      </div>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          if (
                            this.state.paginas >=
                            this.state.paginaActual + 1
                          ) {
                            this.setVisitasPage(this.state.paginaActual + 1);
                          }
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-right"></i>
                      </button>
                    </li>
                    <li className="page-item">
                      <button
                        onClick={() => {
                          this.setVisitasPage(this.state.paginas);
                        }}
                        className="page-link"
                      >
                        <i className="fa fa-angle-double-right"></i>
                      </button>
                    </li>
                  </ul>
                  <div className="ml-3 mr-1">Página:</div>
                  <div className="width-50 mx-2">
                    <input
                      className="form-control"
                      onChange={this.handleVisitasPage}
                      type="number"
                      min="1"
                      max={this.state.paginas}
                      value={this.state.paginaActual}
                    />
                  </div>
                  <div></div>
                </div>
              </div>
            </TabPane>
          </TabContent>

          <div className={this.state.previa ? "previa" : "hide"}>
            <iframe
              title="Vista previa"
              className="rounded"
              src={this.state.previa_url}
              loading="eager"
            ></iframe>
            <center>
              <div className="btn-group">
                <button
                  onClick={() => {
                    this.setState({ previa: false });
                  }}
                  className="btn btn-danger"
                >
                  Regresar
                </button>
                <a
                  className="btn btn-primary"
                  href={this.state.previa_url + "&download=1"}
                  download="download"
                >
                  Descargar
                </a>
              </div>
            </center>
          </div>
        </div>
      </div>
    );
  }
}

export default VisitDrycip;